<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import TokenSelector from './TokenSelector.svelte';
	import { format } from 'svelte-i18n';
	import type { Device } from '../../../../types/Device';

	// device is provided for reference but channel info comes from channels prop
	export let device: Device | null = null;
	export let channels: number[] = [0];
	export let selectedChannel: number = 0;
	export let visible: boolean = true;

	const dispatch = createEventDispatcher<{
		channelSelected: number;
		change: number;
	}>();

	$: hasMultipleChannels = channels && channels.length > 1;
	$: showSelector = visible && hasMultipleChannels;

	// Convert channel indices to display format (1-indexed for UI, Design System expects 'title' not 'label')
	$: channelOptions = channels.map((channelIndex) => ({
		title: $format('label_channel_number', {
			default: `Channel ${channelIndex + 1}`,
			values: { number: channelIndex + 1 },
		}),
		value: channelIndex.toString(),
	}));

	function handleChannelChange(event: CustomEvent) {
		const detail = event.detail;
		const value =
			typeof detail === 'string'
				? detail
				: typeof detail === 'object' && detail && 'value' in detail
					? detail.value
					: detail;
		const channelIndex = parseInt(String(value), 10);
		dispatch('channelSelected', channelIndex);
		dispatch('change', channelIndex);
	}
</script>

{#if showSelector}
	<div class="channel-selector">
		<TokenSelector
			ariaLabel={$format('label_select_channel', { default: 'Channel' })}
			label={$format('label_select_channel', { default: 'Channel' })}
			options={channelOptions}
			value={selectedChannel.toString()}
			on:change={handleChannelChange}
		/>
	</div>
{/if}

<style>
	.channel-selector {
		margin-bottom: 1rem;
	}
</style>
